/**
 * A lightweight youtube embed. Still should feel the same to the user, just MUCH faster to initialize and paint.
 *
 * Thx to these as the inspiration
 *   https://storage.googleapis.com/amp-vs-non-amp/youtube-lazy.html
 *   https://autoplay-youtube-player.glitch.me/
 *
 * Once built it, I also found these:
 *   https://github.com/ampproject/amphtml/blob/master/extensions/amp-youtube (👍👍)
 *   https://github.com/Daugilas/lazyYT
 *   https://github.com/vb/lazyframe
 */ function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _construct(Parent, args, Class) {
    if (_is_native_reflect_construct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _set_prototype_of(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrap_native_super = function wrapNativeSuper(Class) {
        if (Class === null || !_is_native_function(Class)) return Class;
        if (typeof Class !== "function") {
            throw new TypeError("Super expression must either be null or a function");
        }
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _get_prototype_of(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _set_prototype_of(Wrapper, Class);
    };
    return _wrap_native_super(Class);
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var LiteYTEmbed = /*#__PURE__*/ function(HTMLElement1) {
    "use strict";
    _inherits(LiteYTEmbed, HTMLElement1);
    var _super = _create_super(LiteYTEmbed);
    function LiteYTEmbed() {
        _class_call_check(this, LiteYTEmbed);
        return _super.apply(this, arguments);
    }
    _create_class(LiteYTEmbed, [
        {
            key: "connectedCallback",
            value: function connectedCallback() {
                var _this = this;
                this.videoId = this.getAttribute("videoid");
                var playBtnEl = this.querySelector(".lty-playbtn");
                // A label for the button takes priority over a [playlabel] attribute on the custom-element
                this.playLabel = playBtnEl && playBtnEl.textContent.trim() || this.getAttribute("playlabel") || "Play";
                this.dataset.title = this.getAttribute("title") || "";
                /**
         * Lo, the youtube poster image!  (aka the thumbnail, image placeholder, etc)
         *
         * See https://github.com/paulirish/lite-youtube-embed/blob/master/youtube-thumbnail-urls.md
         */ if (!this.style.backgroundImage) {
                    this.style.backgroundImage = 'url("https://i.ytimg.com/vi/'.concat(this.videoId, '/hqdefault.jpg")');
                    this.upgradePosterImage();
                }
                // Set up play button, and its visually hidden label
                if (!playBtnEl) {
                    playBtnEl = document.createElement("button");
                    playBtnEl.type = "button";
                    playBtnEl.classList.add("lty-playbtn");
                    this.append(playBtnEl);
                }
                if (!playBtnEl.textContent) {
                    var playBtnLabelEl = document.createElement("span");
                    playBtnLabelEl.className = "lyt-visually-hidden";
                    playBtnLabelEl.textContent = this.playLabel;
                    playBtnEl.append(playBtnLabelEl);
                }
                this.addNoscriptIframe();
                // for the PE pattern, change anchor's semantics to button
                if (playBtnEl.nodeName === "A") {
                    playBtnEl.removeAttribute("href");
                    playBtnEl.setAttribute("tabindex", "0");
                    playBtnEl.setAttribute("role", "button");
                    // fake button needs keyboard help
                    playBtnEl.addEventListener("keydown", function(e) {
                        if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            _this.activate();
                        }
                    });
                }
                // On hover (or tap), warm up the TCP connections we're (likely) about to use.
                this.addEventListener("pointerover", LiteYTEmbed.warmConnections, {
                    once: true
                });
                this.addEventListener("focusin", LiteYTEmbed.warmConnections, {
                    once: true
                });
                // Once the user clicks, add the real iframe and drop our play button
                // TODO: In the future we could be like amp-youtube and silently swap in the iframe during idle time
                //   We'd want to only do this for in-viewport or near-viewport ones: https://github.com/ampproject/amphtml/pull/5003
                this.addEventListener("click", this.activate);
                // Chrome & Edge desktop have no problem with the basic YouTube Embed with ?autoplay=1
                // However Safari desktop and most/all mobile browsers do not successfully track the user gesture of clicking through the creation/loading of the iframe,
                // so they don't autoplay automatically. Instead we must load an additional 2 sequential JS files (1KB + 165KB) (un-br) for the YT Player API
                // TODO: Try loading the the YT API in parallel with our iframe and then attaching/playing it. #82
                this.needsYTApi = this.hasAttribute("js-api") || navigator.vendor.includes("Apple") || navigator.userAgent.includes("Mobi");
            }
        },
        {
            key: "fetchYTPlayerApi",
            value: function fetchYTPlayerApi() {
                var _this = this;
                if (window.YT || window.YT && window.YT.Player) return;
                this.ytApiPromise = new Promise(function(res, rej) {
                    var el = document.createElement("script");
                    el.src = "https://www.youtube.com/iframe_api";
                    el.async = true;
                    el.onload = function(_) {
                        YT.ready(res);
                    };
                    el.onerror = rej;
                    _this.append(el);
                });
            }
        },
        {
            key: "getYTPlayer",
            value: /** Return the YT Player API instance. (Public L-YT-E API) */ function getYTPlayer() {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!_this.playerPromise) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.activate()
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    _this.playerPromise
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "addYTPlayerIframe",
            value: function addYTPlayerIframe() {
                var _this = this;
                return _async_to_generator(function() {
                    var videoPlaceholderEl, paramsObj;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.fetchYTPlayerApi();
                                return [
                                    4,
                                    _this.ytApiPromise
                                ];
                            case 1:
                                _state.sent();
                                videoPlaceholderEl = document.createElement("div");
                                _this.append(videoPlaceholderEl);
                                paramsObj = Object.fromEntries(_this.getParams().entries());
                                _this.playerPromise = new Promise(function(resolve) {
                                    var player = new YT.Player(videoPlaceholderEl, {
                                        width: "100%",
                                        videoId: _this.videoId,
                                        playerVars: paramsObj,
                                        events: {
                                            "onReady": function(event) {
                                                event.target.playVideo();
                                                resolve(player);
                                            }
                                        }
                                    });
                                });
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            // Add the iframe within <noscript> for indexability discoverability. See https://github.com/paulirish/lite-youtube-embed/issues/105
            key: "addNoscriptIframe",
            value: function addNoscriptIframe() {
                var iframeEl = this.createBasicIframe();
                var noscriptEl = document.createElement("noscript");
                // Appending into noscript isn't equivalant for mysterious reasons: https://html.spec.whatwg.org/multipage/scripting.html#the-noscript-element
                noscriptEl.innerHTML = iframeEl.outerHTML;
                this.append(noscriptEl);
            }
        },
        {
            key: "getParams",
            value: function getParams() {
                var params = new URLSearchParams(this.getAttribute("params") || []);
                params.append("autoplay", "1");
                params.append("playsinline", "1");
                return params;
            }
        },
        {
            key: "activate",
            value: function activate() {
                var _this = this;
                return _async_to_generator(function() {
                    var iframeEl;
                    return _ts_generator(this, function(_state) {
                        if (_this.classList.contains("lyt-activated")) return [
                            2
                        ];
                        _this.classList.add("lyt-activated");
                        if (_this.needsYTApi) return [
                            2,
                            _this.addYTPlayerIframe(_this.getParams())
                        ];
                        iframeEl = _this.createBasicIframe();
                        _this.append(iframeEl);
                        // Set focus for a11y
                        iframeEl.focus();
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "createBasicIframe",
            value: function createBasicIframe() {
                var iframeEl = document.createElement("iframe");
                iframeEl.width = 560;
                iframeEl.height = 315;
                // No encoding necessary as [title] is safe. https://cheatsheetseries.owasp.org/cheatsheets/Cross_Site_Scripting_Prevention_Cheat_Sheet.html#:~:text=Safe%20HTML%20Attributes%20include
                iframeEl.title = this.playLabel;
                iframeEl.allow = "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture";
                iframeEl.allowFullscreen = true;
                // AFAIK, the encoding here isn't necessary for XSS, but we'll do it only because this is a URL
                // https://stackoverflow.com/q/64959723/89484
                iframeEl.src = "https://www.youtube-nocookie.com/embed/".concat(encodeURIComponent(this.videoId), "?").concat(this.getParams().toString());
                return iframeEl;
            }
        },
        {
            /**
     * In the spirit of the `lowsrc` attribute and progressive JPEGs, we'll upgrade the reliable
     * poster image to a higher resolution one, if it's available.
     * Interestingly this sddefault webp is often smaller in filesize, but we will still attempt it second
     * because getting _an_ image in front of the user if our first priority.
     *
     * See https://github.com/paulirish/lite-youtube-embed/blob/master/youtube-thumbnail-urls.md for more details
     */ key: "upgradePosterImage",
            value: function upgradePosterImage() {
                var _this = this;
                // Defer to reduce network contention.
                setTimeout(function() {
                    var webpUrl = "https://i.ytimg.com/vi_webp/".concat(_this.videoId, "/sddefault.webp");
                    var img = new Image();
                    img.fetchPriority = "low"; // low priority to reduce network contention
                    img.referrerpolicy = "origin"; // Not 100% sure it's needed, but https://github.com/ampproject/amphtml/pull/3940
                    img.src = webpUrl;
                    img.onload = function(e) {
                        // A pretty ugly hack since onerror won't fire on YouTube image 404. This is (probably) due to
                        // Youtube's style of returning data even with a 404 status. That data is a 120x90 placeholder image.
                        // … per "annoying yt 404 behavior" in the .md
                        var noAvailablePoster = e.target.naturalHeight == 90 && e.target.naturalWidth == 120;
                        if (noAvailablePoster) return;
                        _this.style.backgroundImage = 'url("'.concat(webpUrl, '")');
                    };
                }, 100);
            }
        }
    ], [
        {
            key: "addPrefetch",
            value: /**
     * Add a <link rel={preload | preconnect} ...> to the head
     */ function addPrefetch(kind, url, as) {
                var linkEl = document.createElement("link");
                linkEl.rel = kind;
                linkEl.href = url;
                if (as) linkEl.as = as;
                document.head.append(linkEl);
            }
        },
        {
            key: "warmConnections",
            value: /**
     * Begin pre-connecting to warm up the iframe load
     * Since the embed's network requests load within its iframe,
     *   preload/prefetch'ing them outside the iframe will only cause double-downloads.
     * So, the best we can do is warm up a few connections to origins that are in the critical path.
     *
     * Maybe `<link rel=preload as=document>` would work, but it's unsupported: http://crbug.com/593267
     * But TBH, I don't think it'll happen soon with Site Isolation and split caches adding serious complexity.
     */ function warmConnections() {
                if (LiteYTEmbed.preconnected) return;
                // The iframe document and most of its subresources come right off youtube.com
                LiteYTEmbed.addPrefetch("preconnect", "https://www.youtube-nocookie.com");
                // The botguard script is fetched off from google.com
                LiteYTEmbed.addPrefetch("preconnect", "https://www.google.com");
                // Not certain if these ad related domains are in the critical path. Could verify with domain-specific throttling.
                LiteYTEmbed.addPrefetch("preconnect", "https://googleads.g.doubleclick.net");
                LiteYTEmbed.addPrefetch("preconnect", "https://static.doubleclick.net");
                LiteYTEmbed.preconnected = true;
            }
        }
    ]);
    return LiteYTEmbed;
}(_wrap_native_super(HTMLElement));
// Register custom element
customElements.define("lite-youtube", LiteYTEmbed);

//# sourceMappingURL=presentacion.daa4bfa2.js.map
